import { useState } from "react";
import { Redirect } from "react-router";
import { Form, Container, Image } from "react-bootstrap";

import { useAppDispatch, useAppSelector } from "../store/hooks";
import * as authActions from "../store/auth";
import { removeError } from "../store/authSlice";

import Logo from "../image/logoYounicam.png";
import AlertComponent from "../components/AlertComponent";
import CustomLoadingOverlay from "../components/CustomLoadingOverlay";

import styled from "styled-components";
import ButtonComponent from "../components/ButtonComponent";

const LoginWrapper = styled.div`
  color: rgb(226, 221, 221);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background-image: radial-gradient(
    circle,
    #1c294f,
    #1a274c,
    #182549,
    #162346,
    #142143,
    #132042,
    #121e41,
    #111d40,
    #101d41,
    #0f1c42,
    #0e1c42,
    #0d1b43
  );
`;

const StyledForm = styled(Form)`
  width: 600px;
  background-color: #152141;
  padding: 1rem;
  border-radius: 2vh;
  box-shadow: 0 12px 12px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);

  @media (max-width: 767px) {
    width: 80%;
  }
`;

const StyledImage = styled(Image)`
  margin-bottom: 5vh;
  height: 20%;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.16) 0px 0 10px;
  -moz-box-shadow: rgba(0, 0, 0, 0.16) 0 0 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0 0 10px;
`;

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const loading = useAppSelector((state) => state.auth.loading);
  const isAuth = useAppSelector((state) => state.auth.isAuth);
  const error = useAppSelector((state) => state.auth.error);

  const dispatch = useAppDispatch();

  const onLogin = async (username: string, password: string) =>
    dispatch(authActions.login(username, password));

  const onRemoveError = () => dispatch(removeError());

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    await onLogin(username, password);
  };

  if (isAuth && !loading) return <Redirect to="/" />;

  return (
    <Container fluid className="p-0">
      <CustomLoadingOverlay active={loading} fullHeight>
        <LoginWrapper>
          <StyledImage src={Logo} />
          {error && (
            <AlertComponent
              message="Wrong credentials"
              variant="danger"
              onClose={onRemoveError}
            />
          )}
          <StyledForm>
            <h3 className="text-center">Sign in to YoUnicam Dashboard</h3>
            <Form.Group controlId="formBasicEmail" className="mb-2">
              <Form.Label>Username</Form.Label>
              <Form.Control
                className="formControl"
                type="text"
                onChange={(e) => setUsername(e.target.value)}
              />
              <Form.Text>Use your Unicam username</Form.Text>
            </Form.Group>
            <Form.Group controlId="formBasicPassword" className="mb-2">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>
            <ButtonComponent
              disabled={username.length === 0 || password.length === 0}
              type="submit"
              onClick={(e: React.SyntheticEvent) => handleSubmit(e)}
            >
              Sign in
            </ButtonComponent>
          </StyledForm>
        </LoginWrapper>
      </CustomLoadingOverlay>
    </Container>
  );
};

export default LoginPage;
